










































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeTransporteur, {TransporteurFilter} from '@/stores/modules/transporteur';

import InputDateFilter from '@/components/Input/DateFilter.vue';
import CrudFournisseurSearch from '@/components/Crud/Fournisseur/Search.vue';

@Component({
	components: {
		InputDateFilter,
		CrudFournisseurSearch,
	}
})
export default class CrudTransporteurFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce;

	@Stored(() => storeTransporteur) private page!: number;
	@Stored(() => storeTransporteur) private filters!: TransporteurFilter;

	@WatchObjectProperties('filters', TransporteurFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeTransporteur.dispatch('getC', { filters: true });
	}

	public mounted() {
	    this.filters = new TransporteurFilter();
	}
}
